import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { NumberInput, Select } from '@glu/form-components';
import locale from '@glu/locale';
import { withStyles, withTheme } from '@glu/theming';
import SchedulerContext from '../SchedulerContext';
import getMinMaxOptions from './EveryN.util';

export const SELECT = 'SELECT';
export const NUMBER = 'NUMBER';

const styles = {
  every: {
    marginBottom: 20
  },
  input: {
    display: 'inline-block',
    margin: '0 5px',

    '& input': {
      width: 50
    }
  }
};

const EveryN = ({
  classes, everyText, type, exactStep, min, max, step, value, onChange
}) => {
  const {
    htmlId, disabled
  } = useContext(SchedulerContext);
  const init = useRef(false);
  useEffect(() => {
    if (!init.current) {
      switch (type) {
        case NUMBER:
          onChange(htmlId, value);
          break;
        case SELECT:
        default:
          onChange({ target: { value } });
          break;
      }
      init.current = true;
    }
  });
  return (
    <div className={classes.every}>
      {everyText[0]}
      {type === NUMBER && (
        <NumberInput
          htmlId={`${htmlId}-input`}
          name={`${htmlId}-input`}
          data-qa={`${htmlId}-input`}
          className={classes.input}
          labelText={locale.get('schedulerReact.every')}
          screenReaderLabel
          inline
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          readOnly={exactStep}
          onChange={onChange}
          disableInputAPI
        />
      )}
      {type === SELECT && (
        <Select
          htmlId={`${htmlId}-input`}
          name={`${htmlId}-input`}
          data-qa={`${htmlId}-select`}
          className={classes.input}
          labelText={locale.get('schedulerReact.every')}
          options={getMinMaxOptions(min, max)}
          screenReaderLabel
          inline
          value={value}
          disabled={disabled}
          readOnly={exactStep}
          onChange={onChange}
          disableInputAPI
        />
      )}
      {everyText[1]}
    </div>
  );
};

EveryN.propTypes = {
  /** Classes provided by the theme */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** Text to display arround input */
  everyText: PropTypes.instanceOf(Array).isRequired,

  /** Type of control */
  type: PropTypes.oneOf([SELECT, NUMBER]).isRequired,

  /** Disable manual entry of value. The user can change the value only by +- buttons */
  exactStep: PropTypes.bool,

  /** Min value to allow in input */
  min: PropTypes.number.isRequired,

  /** Max value to allow in input */
  max: PropTypes.number.isRequired,

  /** Value to increment with */
  step: PropTypes.number,

  /** Value of input */
  value: PropTypes.number,

  /** Callback to set recurrence value */
  onChange: PropTypes.func.isRequired
};

EveryN.defaultProps = {
  exactStep: false,
  value: 1,
  step: 1
};

export const BareEveryN = EveryN;
export default withTheme(withStyles(styles)(EveryN));
